import { createGlobalStyle } from 'styled-components';
import { colors } from '../constants/colors';

export const GlobalStyle = createGlobalStyle`
    @font-face {
        font-family: 'Clan';
        font-weight: 400;
        font-style: normal;
        src: url('https://grandvision.s3-eu-central-1.amazonaws.com/gon/assets/fonts/ClanOT_400.otf');
    }

    @font-face {
        font-family: 'Clan';
        font-weight: 500;
        font-style: normal;
        src: url('https://grandvision.s3-eu-central-1.amazonaws.com/gon/assets/fonts/ClanOT_500.otf');
    }

    * {
        box-sizing: border-box;
    }

    html,
    body {
        height: 100%;
        margin: 0;
    }

    body {
        font-family: 'Clan', Arial, Helvetica, sans-serif;
        line-height: 1.3;
        color: ${colors.black};
    }

    a {
        color: ${colors.black};
    }
    
    p {
        margin: 0;
        line-height: 1.5;
    }

    h3 {
        margin: 15px 0;
        line-height: 1.5;
    }

    h4 {
        margin: 10px 0;
    }

    button {
        border-radius: 3px;
    }
`;
